const MAX_SIDE = 1600;
export const MAX_BYTES = 2 * 1024 * 1024;

async function decode(file) {
  if (window.createImageBitmap) {
    try { return await createImageBitmap(file, { imageOrientation: "from-image" }); } catch { /* fallback below */ }
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Não consegui ler essa imagem. Tente outra foto.")); };
    img.src = url;
  });
}

// Redraws on canvas: fixes orientation, resizes to 1600px and strips EXIF/GPS metadata.
export async function compressPhoto(file) {
  const src = await decode(file);
  const w = src.width, h = src.height;
  const scale = Math.min(1, MAX_SIDE / Math.max(w, h));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(w * scale);
  canvas.height = Math.round(h * scale);
  canvas.getContext("2d").drawImage(src, 0, 0, canvas.width, canvas.height);
  if (src.close) src.close();
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.8));
  if (!blob) throw new Error("Não consegui processar a foto. Tente de novo.");
  return blob;
}

export const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = reject;
  r.readAsDataURL(blob);
});

export const dataUrlToBlob = async (dataUrl) => (await fetch(dataUrl)).blob();

export const kb = (n) => `${Math.round(n / 1024)} KB`;
